namespace Umbrella {
    import Gender = Umbrella.Modules.Gender;

    @Pipe('Dashboard', 'gender')
    class GenderFilter {
        public transform(gender: string | Gender) {
            switch (gender) {
                case 'Male':
                case Umbrella.Modules.Gender.Male:
                    return 'Man';
                case 'Female':
                case Umbrella.Modules.Gender.Female:
                    return 'Vrouw';
                default:
                    return 'Onbekend';
            }
        }
    }
}
